import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Code, Database, Palette, Zap, Settings, Server, Wrench, RefreshCw, Headphones, ArrowRight } from 'lucide-react'

const Services = () => {
  const services = [
    {
      icon: <Code className="w-10 h-10" data-component-path="client/src/pages/Services.jsx" data-component-line="1:1" data-component-id="client/src/pages/Services.jsx:1:1" />,
      title: 'Web Development',
      description: 'Custom web applications built with modern frameworks and best practices',
      link: '/services/web-development',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: <Database className="w-10 h-10" data-component-path="client/src/pages/Services.jsx" data-component-line="2:1" data-component-id="client/src/pages/Services.jsx:2:1" />,
      title: 'SaaS Development',
      description: 'Scalable multi-tenant platforms with enterprise-grade architecture',
      link: '/services/saas-development',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: <Server className="w-10 h-10" data-component-path="client/src/pages/Services.jsx" data-component-line="3:1" data-component-id="client/src/pages/Services.jsx:3:1" />,
      title: 'Custom Software',
      description: 'Tailored software solutions designed for your unique business needs',
      link: '/services/custom-software',
      color: 'from-green-500 to-emerald-500'
    },
    {
      icon: <Palette className="w-10 h-10" data-component-path="client/src/pages/Services.jsx" data-component-line="4:1" data-component-id="client/src/pages/Services.jsx:4:1" />,
      title: 'UI/UX Engineering',
      description: 'Beautiful, intuitive interfaces that users love',
      link: '/services/ui-ux-engineering',
      color: 'from-orange-500 to-red-500'
    },
    {
      icon: <Zap className="w-10 h-10" data-component-path="client/src/pages/Services.jsx" data-component-line="5:1" data-component-id="client/src/pages/Services.jsx:5:1" />,
      title: 'AI & Automation',
      description: 'Intelligent systems that transform business operations',
      link: '/services/ai-automation',
      color: 'from-yellow-500 to-amber-500'
    },
    {
      icon: <Settings className="w-10 h-10" data-component-path="client/src/pages/Services.jsx" data-component-line="6:1" data-component-id="client/src/pages/Services.jsx:6:1" />,
      title: 'ERP Solutions',
      description: 'Comprehensive enterprise resource planning systems',
      link: '/services/erp-solutions',
      color: 'from-indigo-500 to-blue-500'
    },
    {
      icon: <Server className="w-10 h-10" data-component-path="client/src/pages/Services.jsx" data-component-line="7:1" data-component-id="client/src/pages/Services.jsx:7:1" />,
      title: 'Odoo Implementation',
      description: 'Expert deployment of Odoo ERP for your business',
      link: '/services/odoo-implementation',
      color: 'from-purple-600 to-purple-800'
    },
    {
      icon: <Wrench className="w-10 h-10" data-component-path="client/src/pages/Services.jsx" data-component-line="8:1" data-component-id="client/src/pages/Services.jsx:8:1" />,
      title: 'Odoo Customization',
      description: 'Custom modules and features tailored to your workflow',
      link: '/services/odoo-customization',
      color: 'from-pink-500 to-rose-500'
    },
    {
      icon: <RefreshCw className="w-10 h-10" data-component-path="client/src/pages/Services.jsx" data-component-line="9:1" data-component-id="client/src/pages/Services.jsx:9:1" />,
      title: 'Odoo Migration',
      description: 'Seamless migration to latest Odoo versions',
      link: '/services/odoo-migration',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      icon: <Headphones className="w-10 h-10" data-component-path="client/src/pages/Services.jsx" data-component-line="10:1" data-component-id="client/src/pages/Services.jsx:10:1" />,
      title: 'Odoo Support',
      description: '24/7 maintenance and technical support',
      link: '/services/odoo-support',
      color: 'from-blue-600 to-indigo-600'
    },
    {
      icon: <Headphones className="w-10 h-10" data-component-path="client/src/pages/Services.jsx" data-component-line="11:1" data-component-id="client/src/pages/Services.jsx:11:1" />,
      title: '30 Days Customer Support',
      description: 'Comprehensive post-launch support and training',
      link: '/services/customer-support',
      color: 'from-green-600 to-emerald-600'
    },
  ]

  return (
    <div className="min-h-screen pt-20" data-component-path="client/src/pages/Services.jsx" data-component-line="12:1" data-component-id="client/src/pages/Services.jsx:12:1">
      <section 
        className="relative min-h-[50vh] flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=1920)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        data-component-path="client/src/pages/Services.jsx"
        data-component-line="13:3"
        data-component-id="client/src/pages/Services.jsx:13:3"
      >
        <div className="absolute inset-0 bg-dark-primary/80" data-component-path="client/src/pages/Services.jsx" data-component-line="21:5" data-component-id="client/src/pages/Services.jsx:21:5"></div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-component-path="client/src/pages/Services.jsx" data-component-line="23:5" data-component-id="client/src/pages/Services.jsx:23:5">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            data-component-path="client/src/pages/Services.jsx"
            data-component-line="24:7"
            data-component-id="client/src/pages/Services.jsx:24:7"
          >
            <h1 className="text-5xl md:text-6xl font-bold mb-6" data-component-path="client/src/pages/Services.jsx" data-component-line="29:9" data-component-id="client/src/pages/Services.jsx:29:9">
              Our <span className="text-gradient" data-component-path="client/src/pages/Services.jsx" data-component-line="30:19" data-component-id="client/src/pages/Services.jsx:30:19">Services</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-component-path="client/src/pages/Services.jsx" data-component-line="32:9" data-component-id="client/src/pages/Services.jsx:32:9">
              Comprehensive technology solutions designed to transform your business
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-dark-primary" data-component-path="client/src/pages/Services.jsx" data-component-line="39:3" data-component-id="client/src/pages/Services.jsx:39:3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Services.jsx" data-component-line="40:5" data-component-id="client/src/pages/Services.jsx:40:5">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-component-path="client/src/pages/Services.jsx" data-component-line="41:7" data-component-id="client/src/pages/Services.jsx:41:7">
            {services.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -5 }}
                className="glass-panel rounded-xl p-8 hover:neon-border transition-all group"
                data-component-path="client/src/pages/Services.jsx"
                data-component-line="43:11"
                data-component-id="client/src/pages/Services.jsx:43:11"
              >
                <Link to={service.link} data-component-path="client/src/pages/Services.jsx" data-component-line="51:13" data-component-id="client/src/pages/Services.jsx:51:13">
                  <div className={`w-20 h-20 rounded-xl flex items-center justify-center mb-6 text-white bg-gradient-to-br ${service.color} group-hover:scale-110 transition-transform`} data-component-path="client/src/pages/Services.jsx" data-component-line="52:15" data-component-id="client/src/pages/Services.jsx:52:15">
                    {service.icon}
                  </div>
                  <h3 className="text-2xl font-bold mb-3 text-white" data-component-path="client/src/pages/Services.jsx" data-component-line="55:15" data-component-id="client/src/pages/Services.jsx:55:15">{service.title}</h3>
                  <p className="text-gray-400 mb-4" data-component-path="client/src/pages/Services.jsx" data-component-line="56:15" data-component-id="client/src/pages/Services.jsx:56:15">{service.description}</p>
                  <div className="flex items-center gap-2 text-neon-green font-semibold" data-component-path="client/src/pages/Services.jsx" data-component-line="57:15" data-component-id="client/src/pages/Services.jsx:57:15">
                    Learn More <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-component-path="client/src/pages/Services.jsx" data-component-line="58:28" data-component-id="client/src/pages/Services.jsx:58:28" />
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Services